/* tslint:disable */

/**
 */
export class HistoryShift {
    id?: number;
    user_id?: number;
    shift_id?: number;
    amount?: number;
    created_at?: string;
    updated_at?: string;
    deposit?: number;
    shift_time?: string;
}
